import I18n from 'I18n';
import { I18nLookup } from 'pricing-pages-lib/utils/languageUtils';
import { MARKETING_SMS_SHORT_CODE } from 'self-service-api/constants/ApiNames';
import { BREEZE_PRODUCTS } from 'self-service-api/constants/ProductCategories';
import { useAppSelector } from '../reducers';
import { isUngatedForBreezeIntelligenceSelector } from '../selectors/GatingSelectors';
import { billingNameKeySelector, productForSkuIdSelector, productSelector } from '../selectors/ProductsSelectors';
import { useGlobalLoading } from './loadingHooks';
import { useEligibleAddons } from './useEligibleAddons';
import { useEligibleBreezeProducts } from './useEligibleBreezeProducts';
export const useAllEligibleAddOnsWithTranslations = ({
  searchTerm = ''
} = {}) => {
  const isUngatedForBreezeIntelligence = useAppSelector(isUngatedForBreezeIntelligenceSelector);
  const {
    addOns = [],
    loading: addOnsLoading
  } = useEligibleAddons();
  const {
    eligibleBreezeApiNames,
    loading: getEligibleBreezeSkusLoading
  } = useEligibleBreezeProducts({});
  const combinedList = [...(eligibleBreezeApiNames || []), ...addOns];
  const isAppReady = useGlobalLoading();
  const {
    filteredAddOns,
    totalAddOns
  } = useAppSelector(state => {
    if (!isAppReady) {
      return {
        filteredAddOns: [],
        totalAddOns: 0
      };
    }
    const allAddOns = combinedList.reduce((acc, apiName) => {
      var _product$currentVersi, _product$productCateg;
      const product = productSelector(state, {
        apiName
      });
      const skuId = product === null || product === void 0 || (_product$currentVersi = product.currentVersion) === null || _product$currentVersi === void 0 ? void 0 : _product$currentVersi.skuId;
      const isBreezeProduct = (product === null || product === void 0 || (_product$productCateg = product.productCategory) === null || _product$productCateg === void 0 ? void 0 : _product$productCateg.name) === BREEZE_PRODUCTS;
      if (!skuId) {
        return acc;
      }
      const billingNameKey = billingNameKeySelector(state, {
        skuId
      });
      const i18nKey = `pricing-pages.products.${billingNameKey}.title`;
      const translationExists = I18nLookup(i18nKey);

      // if the translation doesn't exist, don't add it to the list
      if (!translationExists) {
        return acc;
      }
      const title = I18n.text(i18nKey).toLowerCase();
      acc.push({
        skuId,
        title,
        isBreezeProduct
      });
      return acc;
    }, []);
    const filtered = allAddOns.filter(({
      title
    }) => !searchTerm || title.includes(searchTerm.toLowerCase()))
    /**
     * @temporary temporarily pause Marketing SMS Short Code Sales
     * @expiration 2025-06-01
     * @deprecated
     */.filter(({
      skuId
    }) => {
      const {
        apiName
      } = productForSkuIdSelector(state, {
        skuId
      });
      return apiName !== MARKETING_SMS_SHORT_CODE;
    });
    return {
      filteredAddOns: filtered,
      totalAddOns: allAddOns.length
    };
  });
  return {
    addOns: filteredAddOns,
    totalAddOns,
    loading: !isAppReady || addOnsLoading || isUngatedForBreezeIntelligence && getEligibleBreezeSkusLoading,
    loaded: isAppReady && !addOnsLoading && !getEligibleBreezeSkusLoading
  };
};